<div class="linkList" [class.linkList--drawer]="variant === 'drawer'">
  <app-link-list-item
    *ngFor="let link of visibleLinks; trackBy: trackByPath"
    [link]="link"
    [variant]="variant"
    [orderTooltip]="orderTooltip"
    (itemNavigate)="handleNavigate()"
  ></app-link-list-item>
</div>
